module.exports = __webpack_public_path__ + "media/assets/login/icon-pop-f0407d9afda0a54f88a39613c0de635c.svg";